import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasUploaderDirective } from './gas-uploader.directive';


const DIRECTIVES = [
  GasUploaderDirective,
];

@NgModule({
  declarations: [
    DIRECTIVES,
  ],
  exports: [
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasUploaderDirectiveModule  { }
